import { domReady } from './Functions/DomReady';
import { enableSwitcher } from './Functions/LanguageSwitcher';
import { Slider } from './Functions/Slider';
import { StickyNavigation } from './Functions/StickyNavigation';
import { MobileNavigation } from './Functions/MobileNavigation';
import { SvHoverIntent } from './Functions/SvHoverIntent';
import { LinePageSlider } from './Functions/Slider';
import { HistorySliderController } from './Functions/HistorySliderController';

domReady(() => {
  enableSwitcher();
  StickyNavigation();
  Slider();
  MobileNavigation();
  SvHoverIntent();
  LinePageSlider();
  HistorySliderController();
});
